import * as Yup from "yup";

export const supportingDocsValidations = (section, formType, dbFormSpec, languageText) => {
    if (section.active) {
        return Yup.object().shape({
            supportingDoc: (dbFormSpec.idVerification && parseInt(dbFormSpec.idVerification.numOfDocsExpected || 0) > 0) && Yup.array()
                .required(
                    () => `${languageText.ErrorChecking.ValidatorText.PleaseUpload}`
                )
                .test(
                    'file-limit',
                    section.fields.supportingDoc.validations.fileLimit.message,
                    function checkIfFilesAreCorrectType(files) {

                        if (files) {
                            return files.length <= 4;
                        }
                        return true;
                    }
                )
                .test(
                    'file-minimum',
                    section.fields.supportingDoc.validations.fileMinimum.message,
                    function checkIfFilesAreCorrectType(files) {

                        if (files && dbFormSpec.idVerification.numOfDocsExpected === 2 && formType.includes('Patient')) {
                            return files.length > 1;
                        }
                        return true;
                    }
                )
                .test(
                    'is-file-big',
                    `${languageText.ErrorChecking.ValidatorText.IsFileBig}`,
                    function checkIfFilesAreCorrectSize(files) {
                        let valid = true
                        if (files) {
                            files.map(file => {
                                if (file.size > 1.5e+7) {
                                    valid = false
                                }
                            })
                        }
                        return valid
                    }
                )
        });
    } else {
        return Yup.object().shape();
    }
};


export const supportingDocsValidationsProxy = (section, formType, dbFormSpec, languageText) => {
    if (formType === "Representative") {
        return Yup.object().shape({
            supportingDocProxy: (dbFormSpec.idVerificationProxy && parseInt(dbFormSpec.idVerificationProxy.numOfDocsExpected || 0) > 0) && Yup.array()
                .required(
                    () =>
                        `${languageText.ErrorChecking.ValidatorText.PleaseAlsoUpload}`
                )
                .test(
                    'file-limit',
                    section.fields.supportingDoc.validations.fileLimit.message,
                    function checkIfFilesAreCorrectType(files) {

                        if (files) {
                            return files.length <= 4;
                        }
                        return true;
                    }
                )
                .test(
                    'file-minimum',
                    section.fields.supportingDoc.validations.fileMinimum.message,
                    function checkIfFilesAreCorrectType(files) {

                        if (files && dbFormSpec.idVerification.numOfDocsExpected === 2 && formType.includes('Patient')) {
                            return files.length > 1;
                        }
                        return true;
                    }
                )
                .test(
                    'is-file-big',
                    `${languageText.ErrorChecking.ValidatorText.IsFileBig}`,
                    function checkIfFilesAreCorrectSize(files) {
                        let valid = true
                        if (files) {
                            files.map(file => {
                                if (file.size > 1.5e+7) {
                                    valid = false
                                }
                            })
                        }
                        return valid
                    }
                ),
            documentationProxy: Yup.string()
                .required(
                    () =>
                        `${languageText.ErrorChecking.ValidatorText.PleaseSelect}`
                )
        });
    } else { return Yup.object().shape(); }
};